import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";

const Method = () => {
  const { t } = useLang();
  return (
    <section id="method" className="py-24 lg:py-32 bg-[var(--ivory)]" data-testid="method-section">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <span className="overline" data-testid="method-overline">{t.method.overline}</span>
          <h2 className="font-serif text-[34px] sm:text-[42px] lg:text-[52px] leading-[1.08] tracking-tight text-[var(--navy)] mt-6" data-testid="method-title">
            {t.method.title}
          </h2>
          <div className="mt-8 w-14 h-px bg-[var(--champagne)]" />
          <p className="mt-8 text-[16px] lg:text-[17px] leading-[1.85] text-[var(--charcoal)]" data-testid="method-intro1">
            {t.method.intro1}
          </p>
          <p className="mt-4 text-[16px] lg:text-[17px] leading-[1.85] text-[var(--charcoal)]" data-testid="method-intro2">
            {t.method.intro2}
          </p>
        </motion.div>

        <div className="mt-20 relative">
          <div className="absolute left-[28px] lg:left-1/2 lg:-translate-x-px top-0 bottom-0 w-px bg-[var(--border-light)]" aria-hidden />
          <div className="space-y-12 lg:space-y-20">
            {t.method.steps.map((step, idx) => {
              const isRight = idx % 2 === 1;
              return (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.7, delay: idx * 0.05 }}
                  className="relative lg:grid lg:grid-cols-2 lg:gap-16 items-start"
                  data-testid={`method-step-${idx}`}
                >
                  {/* node */}
                  <div className="absolute left-[20px] lg:left-1/2 lg:-translate-x-1/2 top-2 w-4 h-4 bg-[var(--ivory)] border border-[var(--champagne)] flex items-center justify-center">
                    <span className="w-1.5 h-1.5 bg-[var(--champagne)]" />
                  </div>

                  <div className={`pl-16 lg:pl-0 ${isRight ? "lg:col-start-2 lg:pl-16" : "lg:pr-16 lg:text-right"}`}>
                    <p className="step-num">{String(idx + 1).padStart(2, "0")}</p>
                    <h3 className="font-serif text-[24px] lg:text-[30px] text-[var(--navy)] mt-3 leading-tight">
                      {step.title}
                    </h3>
                    <p className="mt-4 text-[15px] lg:text-[16px] leading-[1.8] text-[var(--charcoal)] max-w-md lg:max-w-none lg:inline-block">
                      {step.desc}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Method;
